import { Injectable, signal } from '@angular/core';

/**
 * Coordinates `canDeactivate` for the diagram editor without tight coupling to the route component.
 */
@Injectable({ providedIn: 'root' })
export class UnsavedDiagramService {
  /** True while the editor route is active and should be consulted on navigation. */
  readonly editorActive = signal(false);
  readonly hasUnsavedChanges = signal(false);
  private saveHandler: (() => Promise<boolean>) | null = null;

  setEditorActive(active: boolean): void {
    this.editorActive.set(active);
    if (!active) {
      this.hasUnsavedChanges.set(false);
      this.saveHandler = null;
    }
  }

  registerSave(handler: () => Promise<boolean>): void {
    this.saveHandler = handler;
  }

  /** Persist a dirty diagram. Returns true when there is nothing left unsaved. */
  async saveIfDirty(): Promise<boolean> {
    if (!this.editorActive() || !this.hasUnsavedChanges()) return true;
    if (!this.saveHandler) return false;
    return this.saveHandler();
  }

  markDirty(dirty: boolean): void {
    this.hasUnsavedChanges.set(dirty);
  }
}
